import React from "react";
import "../App.css";

function AdminScreen({
                        isAdmin,
                        users,
                        setUsers,
                        distributions,
                        setDistributions,
                        onSaveUser,
                        onDeleteUser,
                        onSaveDist,
                        onDeleteDist,
                        onClose
                    }) {

    // simple update helper
    function update(setter, list, index, field, value) {
        setter(
            list.map((row, i) =>
                i === index ? { ...row, [field]: value } : row
            )
        );
    }

    // add new user row
    function addUser() {
        setUsers([
            {
                user_id: "",
                user_name: "",
                email: "",
                distribution: "",
                admin: false,
                isNew: true
            },
            ...users
        ]);
    }

    // add new distribution row
    function addDistribution() {
        setDistributions([
            {
                distribution: "",
                entity: "",
                disp_name: "",
                category: "",
                isNew: true
            },
            ...distributions
        ]);
    }

    return (
        <div className="admin-container">

            {/* HEADER */}
            <div className="admin-header">
                <h1>Administration</h1>
                <button className="nav-link" onClick={onClose}>
                    Back
                </button>
            </div>

            {/* AUTH WARNING */}
            {!isAdmin && (
                <div className="admin-warning">
                    Administrative access only. Please check user for admin authorization.
                </div>
            )}

            {/* ---------- USERS ---------- */}
            <div className="admin-section">
                <h3>Users</h3>

                <button className="admin-button"
                        disabled={!isAdmin}
                        onClick={addUser}>
                    Add User
                </button>

                <table className="admin-table">
                    <thead>
                    <tr>
                        <th>User ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Distribution</th>
                        <th>Admin</th>
                        <th></th>
                    </tr>
                    </thead>

                    <tbody>
                    {users.map((u, i) => (
                        <tr key={i}>
                            <td>
                                <input
                                    className="admin-input"
                                    value={u.user_id || ""}
                                    disabled={!u.isNew}
                                    onChange={(e) =>
                                        update(setUsers, users, i, "user_id", e.target.value)
                                    }
                                    required
                                />
                            </td>

                            <td>
                                <input
                                    className="admin-input"
                                    value={u.user_name || ""}
                                    onChange={(e) =>
                                        update(setUsers, users, i, "user_name", e.target.value)
                                    }
                                    required
                                />
                            </td>

                            <td>
                                <input
                                    className="admin-input"
                                    value={u.email || ""}
                                    onChange={(e) =>
                                        update(setUsers, users, i, "email", e.target.value)
                                    }
                                    required
                                />
                            </td>

                            <td>
                                <input
                                    className="admin-input"
                                    value={u.distribution || ""}
                                    onChange={(e) =>
                                        update(setUsers, users, i, "distribution", e.target.value)
                                    }
                                    required
                                />
                            </td>

                            <td>
                                <input
                                    type="checkbox"
                                    checked={!!u.admin}
                                    onChange={(e) =>
                                        update(setUsers, users, i, "admin", e.target.checked)
                                    }
                                />
                            </td>

                            <td>

                                <div className="admin-actions">
                                    <button
                                        className="admin-button-secondary"
                                        onClick={async () => {
                                            const ok = window.confirm("Save changes to this user?");
                                            if (!ok) return;
                                            await onSaveUser(u);
                                        }}
                                    >
                                        Save
                                    </button>

                                    <button
                                        className="admin-button-danger"
                                        onClick={async () => {
                                            const ok = window.confirm("Delete this user?");
                                            if (!ok) return;

                                            await onDeleteUser(u);

                                            // remove row immediately
                                            setUsers(users.filter((_, index) => index !== i));
                                        }}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            {/* ---------- DISTRIBUTIONS ---------- */}
            <div className="admin-section">
                <h3>Distributions</h3>

                <button className="admin-button"
                        disabled={!isAdmin}
                        onClick={addDistribution}>
                    Add Distribution
                </button>

                <table className="admin-table">
                    <thead>
                    <tr>
                        <th>Distribution</th>
                        <th>Search Entity</th>
                        <th>Display Name</th>
                        <th>Category</th>
                        <th></th>
                    </tr>
                    </thead>

                    <tbody>
                    {(() => {
                        let lastDistribution = null;
                        let isGray = false;

                        return distributions.map((d, i) => {

                            // toggle background when distribution changes
                            if (d.distribution !== lastDistribution) {
                                isGray = !isGray;
                                lastDistribution = d.distribution;
                            }

                            return (
                                <tr
                                    key={i}
                                    style={{
                                        backgroundColor: isGray ? "#e5e5f5" : "#ffffff"
                                    }}
                                >
                                    <td>
                                        <input
                                            className="admin-input"
                                            value={d.distribution || ""}
                                            onChange={(e) =>
                                                update(setDistributions, distributions, i, "distribution", e.target.value)
                                            }
                                            required
                                        />
                                    </td>

                                    <td>
                                        <input
                                            className="admin-input"
                                            value={d.entity || ""}
                                            onChange={(e) =>
                                                update(setDistributions, distributions, i, "entity", e.target.value)
                                            }
                                            required
                                        />
                                    </td>

                                    <td>
                                        <input
                                            className="admin-input"
                                            value={d.disp_name || ""}
                                            onChange={(e) =>
                                                update(setDistributions, distributions, i, "disp_name", e.target.value)
                                            }
                                            required
                                        />
                                    </td>

                                    <td>
                                        <input
                                            className="admin-input"
                                            value={d.category || ""}
                                            onChange={(e) =>
                                                update(setDistributions, distributions, i, "category", e.target.value)
                                            }
                                            required
                                        />
                                    </td>

                                    <td>
                                        <div className="admin-actions">

                                            <button
                                                className="admin-button-secondary"
                                                onClick={async () => {
                                                    const ok = window.confirm("Save changes to this distribution?");
                                                    if (!ok) return;
                                                    await onSaveDist(d);
                                                }}
                                            >
                                                Save
                                            </button>

                                            <button
                                                className="admin-button-danger"
                                                onClick={async () => {
                                                    const ok = window.confirm("Delete this distribution?");
                                                    if (!ok) return;

                                                    await onDeleteDist(d);

                                                    // Remove row immediately
                                                    setDistributions(distributions.filter((_, idx) => idx !== i));
                                                }}
                                            >
                                                Delete
                                            </button>

                                        </div>
                                    </td>
                                </tr>
                            );
                        });
                    })()}
                    </tbody>
                </table>
            </div>

        </div>
    );
}

export default AdminScreen;